<template>
    <div>
        <!-- 按钮展示 -->
        <div class="margin-bottom-10" v-if="type=='query'">
            <vButton v-if="inquirySym && (formData.status == 1 || formData.status == 2)" class="margin-right-10" theme="success" @click="clicktype('inquiry')">Inquiry</vButton>
            <vButton v-if="confirmSym && formData.status == 2" class="margin-right-10" theme="primary" @click="clicktype('confirm')">Confirm</vButton>
            <vButton v-if="formData.status == 0 || formData.status == 1 || formData.status == 2" class="margin-right-10" theme="error" @click="clicktype('cancel')">Cancel</vButton>
            <Tooltip placement="top" content="DateTime For PickUp&Delivery"><vButton v-if="pudeSym && formData.status == 3" class="margin-right-10" theme="warning" @click="clicktype('bol')">Pu&De</vButton></Tooltip>
            <!-- <vButton v-if="bolSym && formData.status == 3" class="margin-right-10" theme="info" @click="clicktype('bol')">{{$t('global.common.upload',{defaultValue:'上传'})}}BOL</vButton> -->
            <vButton v-if="podSym && formData.status == 4" class="margin-right-10" theme="primary" @click="clicktype('pod')">{{$t('global.common.upload',{defaultValue:'上传'})}}POD</vButton>
        </div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <div>
                <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
                <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="120" />
            </div>
		</compWrapper>

        <compWrapper :title="$t('erp.b2c.product_information',{defaultValue:'产品信息'})" theme="info">
            <compDetail :detailList="detailList" :idsdata="idsdatajson" :querytype="type" ref="detailnews"></compDetail>

            <div v-if="type!='query'" class="text-right">
                <vButton class="margin-right-20" theme="info" @click="submit('0')">{{$t('fbb.inbound.save_draft',{defaultValue:'保存为草稿'})}}</vButton>
                <vButton class="margin-right-20" theme="primary" @click="submit('1')">{{$t('fbb.alloment.save_and_commit',{defaultValue:'保存并提交'})}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
            </div>
		</compWrapper>

        <compWrapper v-if="type=='query'" :title="$t('erp.channel.price_info',{defaultValue:'价格信息'})" theme="error">
            <div class="margin-15">
                <div >
                    <span>{{$t('fbb.truck.pricedetail',{defaultValue:'询价详情'})}}</span>
                    <div v-for="(item,index) in truckEntityList" :key="index" >
                        <vCol span="24" class="margin-left-20 margin-top-10 padding-bottom-10" style="border-bottom: 1px dashed #d1d1d1;">
                            <vCol span="12" style="padding-left:45px">
                                {{$t('fbb.headlogistics.transport_type',{defaultValue:'发运方式'})}}：<span class="font-bold">{{item.shipType == 1 ? 'LTL' : item.shipType == 2 ? 'FTL' : ''}}<a v-if="formData.status == 2" style="margin-left: 10px; color:blue" @click="editPrice(item)">编辑</a></span>
                            </vCol>
                            <vCol span="12" style="padding-left:45px">
                                {{$t('fbb.truck.company', { defaultValue: '卡车公司' })}}：<span class="font-bold" style="margin-left:2px">{{item.company}}</span>
                                <div>{{$t('erp.b2c.money', { defaultValue: '金额' })}}：<span class="font-bold" style="margin-left:2px">{{item.amount}}</span></div>
                                <div>{{$t('', { defaultValue: '保险金额' })}}：<span class="font-bold" style="margin-left:2px">{{item.insuranceAmount}}</span></div>
                                <div>{{$t('erp.b2border.refNo', { defaultValue: '参考号' })}}：<span class="font-bold" style="margin-left:2px">{{item.referenceNo?item.referenceNo:'--'}}</span></div>
                                <div>{{$t('', { defaultValue: '应收金额' })}}：<span class="font-bold" style="margin-left:2px">{{item.receiveAmount}}</span></div>
                                <div>{{$t('', { defaultValue: '应收保险金额' })}}：<span class="font-bold" style="margin-left:2px">{{item.receiveInsuranceAmount}}</span></div>
                            </vCol>
                        </vCol>
                    </div>
                </div>
                <vCol v-if="!truckEntityList" class="margin-left-20 margin-top-10 padding-bottom-10" style="border-bottom: 1px dashed #d1d1d1;"></vCol>
                <div>
                    <div>{{$t('fbb.truck.confirmprice', { defaultValue: '确认询价' })}}</div>
                    <vCol class="margin-left-20 margin-top-10" span="24">
                        <vCol span="12" style="padding-left:45px">
                            {{$t('fbb.headlogistics.transport_type',{defaultValue:'发运方式'})}}：<span class="font-bold">{{companyDetail.shipType == 1 ? 'LTL' : companyDetail.shipType == 2 ? 'FTL' : ''}}</span>
                        </vCol>
                        <vCol span="12" style="padding-left:45px">
                            {{$t('fbb.truck.company', { defaultValue: '卡车公司' })}}：<span class="font-bold">{{companyDetail.company}}</span>
                            <div>{{$t('erp.b2c.money', { defaultValue: '金额' })}}：<span class="font-bold" style="margin-left:2px">{{companyDetail.amount}}</span></div>
                            <!-- <div>{{$t('', { defaultValue: '保险金额' })}}：<span class="font-bold" style="margin-left:25px">{{companyDetail.insuranceAmount}}</span></div> -->
                            <div>{{$t('erp.b2border.refNo', { defaultValue: '参考号' })}}：<span class="font-bold" style="margin-left:2px">{{companyDetail.referenceNo?companyDetail.referenceNo:'--'}}</span></div>
                            <div v-if="formData.status >= 3">{{$t('', { defaultValue: '应收金额' })}}：<span class="font-bold" style="margin-left:2px">{{formData.receiveAmount}}</span></div>
                            <div v-if="formData.status >= 3">{{$t('', { defaultValue: '应收保险金额' })}}：<span class="font-bold" style="margin-left:2px">{{formData.receiveInsuranceAmount}}</span></div>
                        </vCol>
                    </vCol>
                </div>
            </div>
		</compWrapper>

        <compWrapper v-if="type=='query'" :title="$t('',{defaultValue:'提货&送仓'})" theme="warning">
            <div>
                <vForm :label-width="120" ref="form" class="margin-15 clearfix">
                    <vCol span="24">
                        <vCol span="8">
                            <vFormItem label="PickUp Time" >
                                <span class="font-bold">{{formData.pickUpAt}}</span>
                            </vFormItem>
                        </vCol>
                        <vCol span="8">
                            <vFormItem label="Delivery Time">
                                <span class="font-bold">{{formData.deliveryAt}}</span>
                            </vFormItem>
                        </vCol>
                        <vCol span="8">
                            <vFormItem label="Actual Pickup Time">
                                <span class="font-bold">{{formData.actualPickAt}}</span>
                            </vFormItem>
                        </vCol>
                    </vCol>
                </vForm>
            </div>
		</compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="logcolumn"></compLog>
		</compWrapper>

        <!-- 公共弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="closemodalprops"></component>
        </compModal>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpQueryTruckOne,HttpSaveTruckOne,HttpPuDeTruckOne,HttpQueryB2BOrder,HttpB2cAdminList,HttpqueryB2COrder,HttpGetOrgWarehouseAdress,HttpFilterDisabledWarehouse,HttpGetcheckNo,HttpSaveAddress,HttpQueryTransportOrder } from "@/service/bespeak";
import { HttpWareHouseCodeList } from "@/service/allotment";
import compDetail from './detailnew.vue'
import compInquiry from './inquiry.vue'
import compUploadexl from './uploadexl.vue'
import compOrderTable from './ordertable'
import compAddressTable from './addresstable'
import compEditPirce from './editprice.vue'

import { mapState,mapGetters,mapMutations } from "vuex";
export default {
    props:['activeids','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compDetail,
        compInquiry,
        compUploadexl,
        compOrderTable,
        compAddressTable,
        compEditPirce
	},
    data(){
        return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
            formData:{
                isManage:1,
            },
            countries:[],
            loading:false,
            detailList:[],
            idsdatajson:{},
            truckEntityList:[],
            companyDetail:{},
            logList:[],
            operaTypelist:[
                {label:this.$t('global.common.create', { defaultValue: '创建' }),value:0},
                {label:this.$t('fbb.inbound.common_update', { defaultValue: '更新' }),value:1},
                {label:this.$t('erp.distribution.confirm_submit', { defaultValue: '提交' }),value:2},
                {label:this.$t('fbb.truck.addprice', { defaultValue: '添加询价' }),value:3},
                {label:this.$t('fbb.truck.confirmprice', { defaultValue: '确认询价' }),value:4},
                {label:this.$t('fbb.truck.confirmwaretime', { defaultValue: '确认发货到仓时间' }),value:5},
                {label:this.$t('global.common.upload',{defaultValue:'上传'})+'bol',value:6},
                {label:this.$t('fbb.headlogistics.tuotou',{defaultValue:'妥投'}),value:7},
                {label:this.$t('global.common.upload',{defaultValue:'上传'})+'pod',value:8},
                {label:this.$t('global.common.operate_cancel',{defaultValue:'取消'}),value:9},
                {label:this.$t('fbb.inbound.copy_order', { defaultValue: '单据复制' }),value:10},
                {label:this.$t('global.common.upload',{defaultValue:'上传'})+'pallet label',value:11},
            ],
            showOrder:true,
            modalProps:{},
            codeList:[],
            choseWarehouseList:[],
            otherWareList:[{value:'0',label:'Other'}],
            doceindex:0
        }
    },
    created(){
        this.update();
        // 获取各个按钮的权限
        this.confirmSym = this.handleAuth("fbb.truckReservation.confirm");
        this.inquirySym = this.handleAuth("fbb.truckReservation.addInquiry");
        this.pudeSym = this.handleAuth("fbb.truckReservation.updateTime");
        this.bolSym = this.handleAuth("fbb.truckReservation.uploadBol");
        this.podSym = this.handleAuth("fbb.truckReservation.uploadPod");
        this.stockinSym = this.handleAuth("fbb.truckReservation.stockIn");
    },
    computed:{
        ...mapGetters('dictionary', ['getUserManageWarehouseList','getNextOrgList','getSysAllList','getNewAllProductList','getCountryList']),
        getUserManageList(){
            return this.getUserManageWarehouseList.map(item=>{
                return {
                    value:item.attach.id,
                    label:item.label
                }
            })
        },
        getBase(){
            return [
                {
					label: this.$t('fbb.truck.ordertype',{defaultValue:'单据类型'}),
                    key: "orderType",
                    tag:'vSelect',
                    options:[
                        {value: 1,label:'B2B'},
                        {value: 2,label:'B2C'},
                        {value: 4,label:'Transport'},
                        {value: 3,label:'Other'},
                    ],
                    on:{
                        'on-change':(val)=>{
                            if(val == 2){
                                this.showOrder = false;
                            }else{
                                this.showOrder = true;
                            }
                            if(this.doceindex > 0){
                                this.clearAdress();
                                this.formData.linkedNo = '';
                                this.formData.inOrgWarehouseId = '';
                                this.formData.receiveStore = '';
                                this.formData.orgId = '';
                            }
                            this.doceindex = 1
                        }
                    }
                },
                // nextOrgList
                {
					label: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
					key: "linkedNo",
                    required:false,
                    show:this.formData.orderType != 3 && this.type !='query',
                    children: (h) => {
						return <vIcon
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
                    required:this.formData.orderType !=3 ? true :false ,
                    props:{
                        readonly:true,
                        placeholder:this.formData.orderType == 2 ? '请输入配货单号':''
                    }
                },
                {
					label: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
					key: "linkedNo",
                    span:12,
                    required:false,
                    show:this.formData.orderType != 3 && this.type =='query',
                },
                {
					label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
					key: "orgId",
                    tag:'vSelect',
                    options:this.getNextOrgList,
                    required:this.formData.orderType ==3 ? true :false ,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    on:{
                        'on-change':(val)=>{
                            // 根据组织获取对应的组织仓库列表
                            this.getWarehouseList(val)
                        }
                    },
                    render:()=>{
                        if(this.formData.orgId == 0){
                            return '--'
                        }else{
                            return this.findRenderLabel(this.getNextOrgList, this.formData.orgId)
                        }
                    },
                    show:this.formData.orderType == 3
                },
                {
					label: this.$t('',{defaultValue:'预约单号'}),
                    key:'reservationNo',
                    show:this.type==='query'
                },
                {
					label: this.$t('fbb.alloment.receiveWarehouse',{defaultValue:'收货仓库'}),
                    key: "inOrgWarehouseId",
                    tag:'vSelect',
                    options:this.choseWarehouseList.length>0 ? this.choseWarehouseList : this.getUserManageList,
                    show:this.showOrder,
                    props:{
                        filterable:true
                    },
                    on: {
                        "on-attach": (attach, val) => {
                            this.getInWarehouseAttach(attach, val);
                        }
                    },
                    render:()=>{
                        if(this.formData.inOrgWarehouseId == 0){
                            return '--'
                        }else{
                            return this.formData.inOrgWarehouseCode
                        }
                    },
                    required:false
                },
                {
					label: this.$t('fbb.alloment.receive_store',{defaultValue:'目的地地址CODE'}),
					key: "receiveStore",
                    show:this.showOrder,
                    options: this.codeList,
                    props: {
                        filterable: true
                    },
                },

                {
					label: this.$t('fbb.shipper.query',{defaultValue:'发货地址'}),
					key: "address",
                    span:this.formData.orderType == 3 && this.type!='query' ? 6 : 12,
                },
                {
                    labelWidth:0,
                    span:this.formData.orderType == 3 && this.type!='query' ? 6 : 0,
                    tag: "div",
                    children: (h) => {
						return <div>
                        <vButton theme="info" class="margin-left-10" nativeOnClick={this.getAddress.bind(this,'delivery')}>地址簿</vButton>
                        <vButton theme="success" class="margin-left-10" nativeOnClick={this.saveAddress.bind(this,'delivery')}>保存到地址簿</vButton>
                        </div>
					},
					show:this.type !='query'
                },
                {
					label: this.$t('fbb.alloment.ship_to_address',{defaultValue:'目的地地址'}),
					key: "shipToAddress",
                    span:this.formData.orderType != 2 && this.type!='query' ? 6 : 12,
                },
                {
                    labelWidth:0,
                    span:this.formData.orderType != 2 && this.type!='query' ? 6 : 0,
                    tag: "div",
                    children: (h) => {
                        return <div>
                        <vButton theme="info" class="margin-left-10" nativeOnClick={this.getAddress.bind(this,'receive')}>地址簿</vButton>
                        <vButton theme="success" class="margin-left-10" nativeOnClick={this.saveAddress.bind(this,'receive')}>保存到地址簿</vButton>
                        </div>
					},
					show:this.type !='query'
                },
                {
					label: this.$t('erp.b2c.city',{defaultValue:'城市'}),
					key: "city",
                },
                {
					label: this.$t('fbb.alloment.ship_to_city',{defaultValue:'目的地城市'}),
					key: "shipToCity",
                },
                {
					label: this.$t('erp.b2c.search_state',{defaultValue:'州/省份'}),
					key: "state",
                },
                {
					label: this.$t('fbb.alloment.ship_to_state',{defaultValue:'目的地州/省份'}),
					key: "shipToState",
                },
                {
					label: this.$t('erp.channelbase.country',{defaultValue:'国家'}),
					key: "country",
                    options:this.getCountryList,
                    props:{
                        filterable:true
                    },
                },
                {
					label: this.$t('fbb.alloment.ship_to_country',{defaultValue:'目的地国家'}),
					key: "shipToCountry",
                    options:this.getCountryList,
                    props:{
                        filterable:true
                    },
                },
                {
					label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
					key: "postal",
                },
                {
					label: this.$t('fbb.alloment.ship_to_postal',{defaultValue:'目的地邮编'}),
					key: "shipToPostal",
                },
                {
					label: this.$t('global.common.deliveryWarehouse',{defaultValue:'发货仓库'}),
                    key: "orgWarehouseId",
                    tag:'vSelect',
                    options:this.formData.orderType == 3 ? this.otherWareList : this.choseWarehouseList.length>0 ? this.choseWarehouseList : this.getUserManageList,
                    props:{
                        filterable:true
                    },
                    render:()=>{
                        if(this.formData.orgWarehouseId == 0){
                            return '--'
                        }else{
                            return this.formData.orgWarehouseCode
                        }
                    },
                },
                {
                    label:this.$t('global.common.project',{defaultValue:'项目'}),
                    key:'lineId',
                    tag:'vSelect',
                    options:this.getNewAllProductList,
                    props:{
                        disabled:true,
                    },
                    required:false,
                    show:this.formData.orderType != 3,
                    // lineId
                },
                {
					label: this.$t('global.common.notes',{defaultValue:'备注'}),
					key: "remark",
                    required:false,
                },
                {
                    label:this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key:'organizationId',
                    tag:'vSelect',
                    options:this.getSysAllList,
                    props:{
                        disabled:true,
                    },
                    required:false,
                    show:this.formData.orderType != 3,
                    // lineId
                },
                {
					label: this.$t('erp.deliverychannel.sender',{defaultValue:'发件人'}),
					key: "contact",
                    required:false,
                    show:this.formData.orderType == 3 || this.formData.orderType == 1,
                    props:{
                        disabled:this.formData.orderType == 2 || this.formData.orderType == 1 ? true : false,
                    },

                },
                {
					label: this.$t('erp.b2c.recipients',{defaultValue:'收件人'}),
					key: "shipToContact",
                    required:false,
                    show:this.formData.orderType == 2 || this.formData.orderType == 3,
                    props:{
                        disabled:this.formData.orderType == 2 ? true : false,
                    },

                },

                {
					label: this.$t('fbb.alloment.ship_to_telephone',{defaultValue:'电话'}),
					key: "mobile",
                    required:false,
                    show:this.formData.orderType == 3 || this.formData.orderType == 1,
                    props:{
                        disabled:this.formData.orderType == 2 || this.formData.orderType == 1 ? true : false,
                    },
                },
                {
					label: this.$t('fbb.alloment.ship_to_telephone',{defaultValue:'电话'}),
					key: "shipToMobile",
                    required:false,
                    show:this.formData.orderType == 2 || this.formData.orderType == 3,
                    props:{
                        disabled:this.formData.orderType == 2 ? true : false,
                    },
                },
                {
					label: this.$t('fbb.shipper.query',{defaultValue:'发货地址'})+'Code',
					key: "addressCode",
                    required:false,
                    show:this.formData.orderType == 3,
                },
                {
					label: this.$t('global.common.source_number',{defaultValue:'来源单号'}),
					key: "linkedNo",
                    show:this.formData.orderType == 3,
                    props:{
                        disabled:this.formData.orderType == 2 ? true : false,
                    },
                },


            ]
        },
        logcolumn(){
            return [
                {
                    title:this.$t('global.common.operator',{defaultValue:'操作人'}),
                    key:'createdName',
                    width:90,
                },
                {
                    title:this.$t('global.common.operate_time',{defaultValue:'操作时间'}),
                    key:'updatedAt',
                },
                {
                    title:this.$t('global.common.operate_type',{defaultValue:'操作类型'}),
                    render:(h,{row})=>{
                        return this.findRenderLabel(this.operaTypelist, row.operateType);
                    }
                },
                {
                    title:this.$t('erp.b2c.attachment_information',{defaultValue:'附件信息'}),
                    render(h, { row }) {
                        let extraData = JSON.parse(row.extraData)
                        if (extraData) {
                            return (extraData.items || []).map(json => {
                                return <div>
                                    <a onClick={this.handleWebfs.bind( this, json.attachUrl, {}, "download" )}>
                                        {json.attachTitle || "-"}
                                    </a>
                                </div>
                            })
                        } else return '--'
                    }
                },
                {
                    title:this.$t('global.common.notes',{defaultValue:'备注'}),
                    key:'remark',
                },

            ]
        }

    },
    methods:{
        editPrice(obj){
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show:true,
                title: '编辑询价',
                component: "compEditPirce",
                width:800,
                showFooter:false,
                initData: obj,
                orderid:this.id,
                on:{
                    'on-close':()=>{
                        this.modalProps = {}
                        this.update()
                    }
                }
            }
        },
        getAddress(type){
            let _this = this;
            switch(type){
                case 'delivery':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show:true,
                        title: '查询发货地址簿',
                        component: "compAddressTable",
                        width:1000,
                        addresstype:'delivery',
                        showFooter:false,
                        on:{
                            'cancel':()=>{
                                this.modalProps = {}
                            },
                            'rows':(rows)=>{
                                this.formData.addressCode = rows.addressCode;
                                this.formData.city = rows.city;
                                this.formData.state = rows.state;
                                this.formData.country = rows.country;
                                this.formData.postal = rows.postal;
                                this.formData.contact = rows.linkman;
                                this.formData.mobile = rows.phone;
                                this.$set(this.formData,'address',rows.address);
                                this.modalProps = {};

                            }

                        }
                    }
                break;
                case 'receive':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show:true,
                        title: '查询收货地址簿',
                        component: "compAddressTable",
                        width:1000,
                        addresstype:'receive',
                        showFooter:false,
                        on:{
                            'cancel':()=>{
                                this.modalProps = {}
                            },
                            'rows':(rows)=>{
                                this.$set(this.formData,'shipToAddress',rows.address);
                                this.formData.shipToAddress = rows.address;
                                this.formData.receiveStore = rows.addressCode;
                                this.formData.shipToCity = rows.city;
                                this.formData.shipToState = rows.state;
                                this.formData.shipToCountry = rows.country;
                                this.formData.shipToPostal = rows.postal;
                                this.formData.shipToContact = rows.linkman;
                                this.formData.shipToMobile= rows.phone;
                                this.formData.organizationId = rows.orgId;
                                this.formData.orgId = rows.orgId;
                                this.formData.lineId = '';
                                this.formData.linkedNo = '';
                                this.modalProps = {};
                            }

                        }
                    }
                break;
            }
        },
        saveAddress(type){
            // console.log(type)
            let datajson = {};
            switch(type){
                case 'delivery':
                    if(!this.formData.addressCode){
                        this.$VMessage.error('请输入发货地址Code');
                        return ;
                    }
                    datajson = {
                        type:0,
                        addressCode : this.formData.addressCode,
                        address: this.formData.address,
                        city : this.formData.city,
                        state : this.formData.state,
                        country : this.formData.country,
                        postal : this.formData.postal,
                        linkman : this.formData.contact,
                        phone  : this.formData.mobile,
                    }
                break;
                case 'receive':
                    datajson = {
                        type:1,
                        addressCode : this.formData.receiveStore,
                        address: this.formData.shipToAddress,
                        city : this.formData.shipToCity,
                        state : this.formData.shipToState,
                        country : this.formData.shipToCountry,
                        postal : this.formData.shipToPostal,
                        linkman : this.formData.shipToContact,
                        phone  : this.formData.shipToMobile,
                        orgId : this.formData.orgId || this.formData.organizationId,
                    }
                break;
            }
            HttpSaveAddress({...datajson}).then(res=>{
                this.$VMessage.success(res.message);
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            });

        },
        handleModalplat(){
            if(!this.formData.orderType){ this.$Message.error('请选择单据类型'); return;}
            let ordertitle='';
            switch(this.formData.orderType){
                case 1:ordertitle='查询B2B单号';break;
                case 2:ordertitle='查询B2C单号';break;
                case 4:ordertitle='查询Transport单号';break;
            }
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show:true,
                title: ordertitle,
                component: "compOrderTable",
                width:800,
                showFooter:false,
                ordertype:this.formData.orderType,
                linkedNo:this.formData.linkedNo,
                on:{
                    'cancel':()=>{
                        this.modalProps = {}
                    },
                    'rows':(rows)=>{
                        this.clearAdress();
                        this.formData.linkedNo = this.formData.orderType==2?rows.deliverOrderNo:this.formData.orderType==1?rows.subTransferPlanNo:rows.transitPlanOrderNo;
                        // 先检查是否有重复单子
                        HttpGetcheckNo({
                            orderType:this.formData.orderType,
                            linkedNo:this.formData.linkedNo
                        }).then(res=>{
                        },err=>{
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        })
                        this.getLinkNoDetil(rows);
                        this.modalProps = {}
                    }

                }
            }
        },
        clicktype(type){
            switch(type){
                case 'confirm':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        title:'confirm',
                        width: 560,
                        component: "compInquiry",
                        showFooter:false,
                        boxtype:'typesubmit',
                        querytype:'query',
                        orderid:this.id,
                        truckList:this.truckEntityList,
                        on:{
                            'on-update':()=>{
                                this.update()
                            }
                        }
                    };
                break;
                case 'inquiry':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        title:'Inquiry',
                        width: 560,
                        component: "compInquiry",
                        showFooter:false,
                        boxtype:'typeinquiry',
                        querytype:'edit',
                        orderid:this.id,
                        on:{
                            'on-update':()=>{
                                this.update()
                            }
                        }
                    };
                break;
                case 'cancel':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        title:'Cancel',
                        width: 560,
                        component: "compInquiry",
                        showFooter:false,
                        boxtype:'typecancel',
                        querytype:'edit',
                        orderid:this.id,
                        on:{
                            'on-update':()=>{
                                this.update()
                            }
                        }
                    };
                break;
                case 'bol':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        title: 'Pu&De',
                        width: 560,
                        component: "compUploadexl",
                        showFooter:false,
                        boxtype:'typebol',
                        querytype:'edit',
                        linkedNo:this.formData.linkedNo,
                        orderid:this.id,
                        on:{
                            'on-update':()=>{
                                this.update()
                            }
                        }
                    };
                break;

                case 'pod':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        title:this.$t('global.common.upload',{defaultValue:'上传'})+'pod',
                        width: 560,
                        component: "compUploadexl",
                        showFooter:false,
                        boxtype:'typepod',
                        querytype:'edit',
                        orderid:this.id,
                        on:{
                            'on-update':()=>{
                                this.update()
                            }
                        }
                    };
                break;
            }
        },
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
        // 根据组织获取对应的组织仓库列表
        getWarehouseList(contextId){
            HttpFilterDisabledWarehouse(contextId).then(res=>{
                // console.log(res.data,'yyyrirhrirhib')
                this.choseWarehouseList = res.data.map(item=>{
                    return {
                        value:item.id,
                        label:item.code+'('+item.title+')',
                        attach:{
                            code:item.code,
                            warehouseType:item.warehouseType,
                        }
                    }
                })
            })
        },
        // 请求目的地code接口
        getInWarehouseAttach(attach, val){
            // console.log(attach,val)
            this.formData.inOrgWarehouseCode = attach.code;
            //当仓库是亚马逊仓时，需要传递仓库code
            if (attach.warehouseType == 2) {
                this.codeList = [];
                this.formData.receiveStore = "";
                this.getWHCodeList(val);
                return;
            }else{
                this.formData.receiveStore = attach.code;
                this.codeList = [];
                return;
            }
        },
        //仓库code list
        getWHCodeList(val) {
            if (this.type === "query" || !val) return;
            HttpWareHouseCodeList({
                warehouseId: val
            }).then(
                res => {
                this.codeList = res.data || [];
                },
                err => {
                this.$VMessage.error(err.message);
                }
            );
        },
        // 请求单据接口
        getLinkNoDetil(orderrow){
            let _this = this;
            if(this.formData.orderType == 2){
                // 查询详情内容目的地
                HttpqueryB2COrder({
                    deliverOrderId:orderrow.id
                }).then(res=>{
                    this.$set(this.formData,'shipToAddress',res.data.shipToAddress1);
                    this.$set(this.formData,'shipToCity',res.data.shipToCity);
                    this.$set(this.formData,'shipToState',res.data.shipToState);
                    this.$set(this.formData,'shipToCountry',res.data.shipToCountry);
                    this.$set(this.formData,'shipToPostal',res.data.shipToPostal);
                    this.$set(this.formData,'shipToContact',res.data.shipToContact);
                    this.$set(this.formData,'shipToMobile',res.data.shipToMobile);
                    this.$set(this.formData,'orgWarehouseId',res.data.orgWarehouseId);
                    this.$set(this.formData,'lineId',res.data.lineId);
                    this.$set(this.formData,'orgId',res.data.orgId);
                    this.$set(this.formData,'linkedId',res.data.id);
                    this.$set(this.formData,'organizationId',res.data.orgId);

                    this.getWarehouseList(res.data.orgId);

                })
                // 获取出库地址
                HttpGetOrgWarehouseAdress({
                        orgWarehouseId:orderrow.orgWarehouseId
                    }).then(res=>{
                        // console.log(res.data)
                        this.$set(this.formData,'address',res.data.address);
                        this.$set(this.formData,'city',res.data.city);
                        this.$set(this.formData,'state',res.data.state);
                        this.$set(this.formData,'country',res.data.country);
                        this.$set(this.formData,'postal',res.data.postal);

                    })
            }else{
                let request,
                params = {};
                switch (this.formData.orderType) {
                    case 4:
                        request = HttpQueryTransportOrder;
                        params = { id:orderrow.id };
                        break;
                    default:
                        request = HttpQueryB2BOrder;
                        params = { id:orderrow.id };
                        break;
                }
                request(params).then((res) => {
                    if(!res.data){
                        this.$VMessage.error(res.message);
                        return;
                    }
                    // 各个内容单独赋值
                    let {orgWarehouseId,inOrgWarehouseId,inOrgWarehouseCode,country,state,city,postal,address1,shipToCountry,shipToState,shipToCity,shipToPostal,shipToAddress1,remark,receiveStore,lineId,organizationId,contact,mobile} = res.data
                    this.formData = {...this.formData,orgWarehouseId,inOrgWarehouseId,inOrgWarehouseCode,country,state,city,postal,shipToCountry,shipToState,shipToCity,shipToPostal,remark,receiveStore,lineId,organizationId,contact,mobile};
                    this.idsdatajson = {shipmentId:res.data.shipmentId,removeOrderId:res.data.removeOrderId};

                    this.getWarehouseList(res.data.organizationId);

                    this.$set(this.formData,'address',address1);
                    this.$set(this.formData,'shipToAddress',shipToAddress1);
                    this.$set(this.formData,'orgId',organizationId);
                    this.$set(this.formData,'organizationId',organizationId);
                    this.$set(this.formData,'linkedId',res.data.id);
                }).catch((err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                });
                // b2b和other
                // HttpQueryB2BOrder({
                //     id:orderrow.id
                // }).then(res=>{


                // },err=>{
                //     this.$VMessage.error({
                //         content: err.message,
                //         duration: 30,
                //         closable: true
                //     });
                // })
            }
        },
        clearAdress(){
            this.formData.shipToAddress = this.formData.shipToCity = this.formData.shipToState = this.formData.shipToCountry = this.formData.shipToPostal = this.formData.inOrgWarehouseCode = this.formData.inOrgWarehouseId = this.formData.orgWarehouseId = this.formData.address = this.formData.city = this.formData.state = this.formData.country = this.formData.postal  = this.formData.linkedNo = this.formData.lineId = this.formData.organizationId = this.formData.addressCode = this.formData.contact = this.formData.mobile = this.formData.shipToContact = this.formData.shipToMobile = ''
        },
        update(){
            if(this.type == 'add') return
            if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
            }
            HttpQueryTruckOne({
                id:this.id
            }).then(res=>{
                this.companyDetail = res.data;
                this.formData = res.data.truckReservationEntity;
                this.$set(this.formData,'organizationId',res.data.truckReservationEntity.orgId);
                this.formData.organizationId = res.data.truckReservationEntity.orgId;
                this.getWarehouseList(this.formData.orgId);
                this.detailList = res.data.truckReservationItemEntityList || [];
                this.idsdatajson = {shipmentId:res.data.truckReservationEntity.shipmentId,removeOrderId:res.data.truckReservationEntity.removeOrderId};
                this.truckEntityList = res.data.truckReservationInquiryEntityList;
                this.logList = res.data.orderLogEntityList;
                if(this.formData.orderType == 2){
                    this.showOrder = false;
                }
            },err=>{
               this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        async submit(subtype){
            let bool1 = await this.$refs.baseform.validate()
            if (!bool1) return

            let refdetailnewsdata = this.$refs.detailnews;
            this.formData.truckReservationItems = refdetailnewsdata.detailList;
            this.formData.shipmentId = refdetailnewsdata.idsdata.shipmentId;
            this.formData.removeOrderId = refdetailnewsdata.idsdata.removeOrderId;
            this.formData.isSubmit = subtype;
            this.$set(this.formData,'isManage',1)
            // console.log(this.formData)
            this.loading=true;
            HttpSaveTruckOne({
                ...this.formData,
            }).then(res=>{
                this.loading=false;
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.loading=false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'bespeakTruck',
            });
        }
    },
}
</script>
